import { createFileRoute } from '@tanstack/react-router'

import { learnpathsQueries } from '@/http/api/learnpaths'
import { usersQueries } from '@/http/api/users'
import { userGroupQueries } from '@/http/api/usersGroups'
import { UserDetailsPanel } from '@/users/components/UsersDetails/UserDetailsPanel'

export const Route = createFileRoute('/company/_management/users/$userId')({
  loader: ({ context: { queryClient }, params: { userId } }) => {
    queryClient.prefetchQuery(usersQueries.usersDetail(userId))

    // Learning Paths counter
    queryClient.prefetchInfiniteQuery(
      learnpathsQueries.membershipsList(userId, { is_member: true }),
    )

    // User groups counter
    queryClient.prefetchInfiniteQuery(
      userGroupQueries.infiniteList({
        members_ids: [userId],
        sort_by: 'user_group_name',
        sort_order: 'asc',
      }),
    )
  },
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const userId = Route.useParams({ select: (params) => params.userId })

  const handleClose = () => {
    navigate({
      to: '/company/users',
      search: (previous) => previous,
    })
  }

  return <UserDetailsPanel onClose={handleClose} userId={userId} />
}
